export const environment = {
    production: false,
    API_ENDPOINT: 'https://api.dev.api-arrayan.cl/',
    lemu_base: 'https://clientes.dev.api-arrayan.cl/',
    cliente_nuevo: 'https://clientes-v3.development.simplilab.tech/',
    WS_URL: 'wss://luq81qnp8d.execute-api.us-east-2.amazonaws.com/dev',
    recaptcha_key: '6LeIiwctAAAAAMro7u_bTwqK1z6m4U2m7bXb4X8w',
}

